import { render, staticRenderFns } from "./parentcustody.vue?vue&type=template&id=7bf75e3c&scoped=true&"
import script from "./parentcustody.vue?vue&type=script&lang=js&"
export * from "./parentcustody.vue?vue&type=script&lang=js&"
import style0 from "./parentcustody.vue?vue&type=style&index=0&id=7bf75e3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf75e3c",
  null
  
)

export default component.exports